module.exports = __webpack_public_path__ + "img/narrow.77008d02.svg";